import type { AuditLogRecord } from "@hostdock/types";
import { Badge, humanize } from "@hostdock/ui";

export function ActorCell({ entry }: { entry: Pick<AuditLogRecord, "actorType" | "actorLabel"> }) {
  return (
    <div className="flex items-center gap-2">
      <Badge tone={entry.actorType === "ADMIN" ? "accent" : entry.actorType === "CUSTOMER" ? "info" : "neutral"}>{humanize(entry.actorType)}</Badge>
      <span className="truncate">{entry.actorLabel ?? "—"}</span>
    </div>
  );
}

export const actionLabel = (a: string) => humanize(a);
